import React, { useState, useRef, useEffect } from "react";
import "./ChatBot.css";
import AIBotIcon from '../assets/AI_Bot_2.webp';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (isOpen && buttonRef.current) {
      buttonRef.current.style.display = "none";
    } else if (buttonRef.current) {
      buttonRef.current.style.display = "flex";
    }
  }, [isOpen]);

  return (
    <>
      <button
        ref={buttonRef}
        className="chatWidgetButton"
        onClick={() => setIsOpen(true)}
        aria-label="Open chat with support"
        style={{ border: "none" }}
      >
        <img
          src={AIBotIcon}
          alt="Chatbot Icon"
          width={50}
          height={50}
          loading="lazy"
        />
      </button>

      {isOpen && (
        <div className="chatWidgetContainer">
          {/* Custom Close Button Overlay */}
          <button
            className="chatCloseButton"
            onClick={() => setIsOpen(false)}
            aria-label="Close chat"
          >
            ×
          </button>

          <div className="chatWidgetBody" style={{ padding: 0 }}>
            <iframe
              src="https://copilotstudio.microsoft.com/environments/41b29be7-8077-eaa7-ad5f-051b4065b58c/bots/cr271_hirdaramaniSustainHub/webchat?__version__=2"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              title="Hirdaramani Chatbot"
              loading="lazy"
            />
          </div>
        </div>
      )}

    </>
  );
};

export default ChatBot;
